import { useCallback } from 'react';
import i18n from 'i18next';

export const useRegistreringStatusMapping = () => {
    const handleMapping = useCallback(
        (steg?: string) =>
            steg
                ? (i18n.t(`prosjekt.table.registreringStatus.${steg}`) ?? steg)
                : undefined,
        [],
    );

    return { handleMapping };
};
